var _rect, _line, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 25,
    rx: 4.5,
    stroke: "#9B51E0"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 17.5,
    y1: 8,
    x2: 17.5,
    y2: 18,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.3536 13.3536C24.5488 13.1583 24.5488 12.8417 24.3536 12.6464L21.1716 9.46447C20.9763 9.2692 20.6597 9.2692 20.4645 9.46447C20.2692 9.65973 20.2692 9.97631 20.4645 10.1716L23.2929 13L20.4645 15.8284C20.2692 16.0237 20.2692 16.3403 20.4645 16.5355C20.6597 16.7308 20.9763 16.7308 21.1716 16.5355L24.3536 13.3536ZM9 13.5H24V12.5H9V13.5Z",
    fill: "#9B51E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogOut);
export default __webpack_public_path__ + "static/media/LogOut.e4b98e247a2c84c6e242761dd3424db5.svg";
export { ForwardRef as ReactComponent };